module.exports = __webpack_public_path__ + "img/bg.30fb909b.png";